<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {delay, navigate} from "src/components/cabinet/#common/helpers"
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import {createEmailTemplate} from 'src/components/cabinet/#services/createEmailTemplate'

    let nameTemplate = ''
    let keyTemplate = ''
    let htmlContent = ''

    async function create() {
        createEmailTemplate.send({data:{key: keyTemplate, name: nameTemplate, mailTemplate: htmlContent}})

        showAlert.set({
            status: 'success',
            text: 'Mail template successfully created!'
        })

        navigate("/emails");
    }
</script>

<svelte:head>
    <title>Create template</title>
</svelte:head>

<MainLayout title="Create template">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="emails" class="btn btn-primary mb-3">Back</Link>
                <div class="row mb-3">
                    <div class="col-lg-6">
                        <label>Name</label>
                        <input type="text" class="form-control mb-2" bind:value="{nameTemplate}" autofocus>
                        <label>Key</label>
                        <input type="text" class="form-control mb-2" bind:value="{keyTemplate}">
                        <label>HTML</label>
                        <textarea class="textarea form-control" bind:value={htmlContent}></textarea>
                    </div>
                    <div class="col-lg-6 position-relative">
                        <label>Preview</label>
                        <div class="preview form-control">{@html htmlContent}</div>
                    </div>
                </div>
                <button class="btn btn-success" on:click={create}>Create</button>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .textarea {
        height: 480px;
        resize: none;
    }

    .preview {
        height: 550px;
        padding: 0;
        overflow: auto;
    }

    @media (max-width: 991px) {
        .textarea {
            height: 300px;
            margin-bottom: 10px;
        }

        .preview {
            height: 300px;
        }
    }
</style>
